import React from "react";
import PropTypes from "prop-types";

const Datalist = ({ options }) => (
  <datalist id="datalistOptions">
    {options.map((city) => (
      <option key={city} value={city} />
    ))}
  </datalist>
);

Datalist.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Datalist;
